import React from 'react';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import { getRegion } from '../../../../../../utils/Region';
import { useNavigate } from 'react-router-dom';
//------------------------------------------------------------------
import { FadeInImage } from '../../../../../../components/FadeInImage';
import './style.scss';
import { VerticalCard } from '../VerticalCard';
import useRenderChapas from '../../../../../../hooks/useRenderChapas';
import useMenuRedirect from '../../../../../Menu/hooks/useMenuRedirect';
import { PUSHTOHISTORY } from 'constants.js';
import { OverlayCard } from '../OverlayCard';
import { useShowOverlayTitle } from '../../hooks/useShowOverlayTitle';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';

export const DefaultCard = ({ contentInfo, carouselTitle, contentPosition }) => {
  const { isMobile } = useVerifyIsMobile(768);
  const { renderLabel } = useRenderChapas();
  const navigate = useNavigate();
  const { navigateToChannel, nodesSelected } = useMenuRedirect();

  const { showOverlay } = useShowOverlayTitle(contentInfo)

  const handleCardClick = e => {
    e.stopPropagation();

    // gtm event
    pushSelectContentEvent(contentInfo, nodesSelected, carouselTitle, contentPosition);

    // Verificar si no es live para mandar al canal
    if (getContentListV1?.IsLive(contentInfo)) {
      // navegar al canal
      navigateToChannel(contentInfo, PUSHTOHISTORY);
      return;
    }

    //Redireccionamiento
    navigate(
      `/${getRegion()}/vcard/homeuser/${getContentListV1?.titleUri(contentInfo)}/${contentInfo?.id
      }`,
    );
  };

  if (isMobile) return <VerticalCard contentInfo={contentInfo} />;

  return (
    <>
      {showOverlay ? (
        <OverlayCard contentInfo={contentInfo} carouselTitle={carouselTitle} />
      ) : (
        <div className="default-card" onClick={handleCardClick}>
          {renderLabel(contentInfo)}

          <FadeInImage
            imageAlt={'clarovideo'}
            imageSrc={getContentListV1?.getImage(contentInfo, IMG_SIZE?.LARGE)}
            width={258}
            height={145}
            classNames={['default-card__image', 'noselect']}
          />
        </div>
      )}
    </>
  );
};
